// Le contenu du programme de formation Développeur Web (accélérateur Rocket),
// repris du programme du 29/09/2025 et corrigé le 28/09/2026 : modules
// alignés sur le sommaire réel de la plateforme (la méditation guidée et
// jQuery n'existent plus, les animations CSS sont dans HTML/CSS, Bootstrap
// avec Sass dans Bootstrap, Claude Code est ajouté), exemples de pratique
// vérifiés partie par partie, un seul formateur au lieu d'une « équipe
// pédagogique », plus de financement public ni de passerelle vers un titre.
//
// Les données chiffrées ou réglementaires (tarif, délais, résultats,
// handicap, objectifs) ne sont pas ici : le document les lit dans la fiche
// de la page publique (clés trainingFacts_rocket_*), pour ne jamais s'en
// écarter.

const PROJET = [
    "Les projets-passerelles sont des projets que vous devez suivre uniquement grâce à des instructions et sans démonstration de la part de votre formateur. Ils vous permettent ainsi de laisser aller votre imagination tout en respectant un cahier des charges, ce qui est propre à ce que doit faire un développeur professionnel dans la vie de tous les jours.",
    "Son client ne viendra jamais lui faire une démonstration de ce qu'il souhaite, il viendra lui dire ce qu'il veut. C'est le rôle du développeur de proposer au client une démonstration, et non l'inverse.",
    "Le processus créatif est tout aussi important que le côté technique : partir sans démonstration vous permet ainsi de progresser des deux côtés.",
    "Votre projet sera ensuite à envoyer et sera corrigé individuellement par votre formateur.",
];
const COMPETENCE_PROJET =
    "Documenter le déploiement d'une application dynamique web et web mobile";
const CARNET = ["Un cahier de notes", "Une bouteille d'eau", "Un stylo"];

export const ROCKET_PROGRAMME = {
    slug: "rocket",
    cover: {
        title: "Développeur",
        titleAccent: "web full stack",
        subtitle: "L'accélérateur Rocket",
    },
    // Palette pastel depuis le 29/09/2026, comme la page : BeBot avec son
    // ordinateur et les objets du hero en couverture, des scènes des modules
    // pour les ouvertures et la quatrième.
    theme: "pastel",
    coverObjects: [
        ["navigateur", 12, 70, 92, -8],
        ["palette", 384, 40, 78, 8],
        ["code", 0, 250, 86, -6],
        ["mobile", 400, 200, 58, 8],
        ["base", 76, 336, 56, -6],
        ["curseur", 112, 0, 52, -10],
        ["branches", 368, 318, 60, 10],
    ],
    backCover: { image: "module-27.jpg" },
    // Les trois pages d'ouverture de chapitre (formation, pédagogie, après).
    openers: ["en-bref.jpg", "ateliers.jpg", "certification.jpg"],

    presentation: {
        title: "La formation",
        paragraphs: [
            "Tous les plus grands bouleversements de ces dernières années, que ce soit l'intelligence artificielle, la blockchain ou l'IoT (internet of things, les objets connectés), reposent sur une seule chose : internet.",
            "Dans un monde qui évolue aussi vite, il est devenu essentiel de savoir coder.",
            "Ce n'est plus seulement un « truc de geek » mais un incontournable, une sorte de B-A-BA qui permet d'avoir un pied dans l'avenir.",
            "Mais pour ça, encore faut-il bien choisir sa formation pour apprendre à coder.",
            "Notre programme vous donne toutes les clés nécessaires pour vous permettre de vous épanouir et de transformer vos idées en projets concrets.",
        ],
        image: "presentation.jpg",
        banner: "Rejoignez Rocket, notre formation pour devenir développeur web !",
        cards: [
            [
                "Sans horaires fixes",
                "Se lever à 7 heures du matin tous les matins du lundi au vendredi et finir à 18 heures pour suivre ses formations ? Pas chez Believemy.",
            ],
            [
                "100 % en ligne",
                "Prendre la voiture tous les jours, avoir du mal à placer des rendez-vous, devoir patienter sur place le midi… Nous avons une autre philosophie.",
            ],
            [
                "Sur-mesure",
                "Chacun est unique, nous avons tous nos propres forces, autant miser sur elles dans une formation qui nous apprend à le faire.",
            ],
        ],
    },

    job: {
        title: "Un poste dans le palmarès des métiers les plus recherchés au monde",
        quote: "« La France manque de développeurs informatiques » France Info.",
        paragraphs: [
            "En France, certaines études parlent d'une pénurie de 80 000 spécialistes en informatique à travers l'Hexagone.",
            "Dans cette optique, nous ne sommes pas mal logés comparés au reste du monde, avec par exemple le plan France 2030 sur l'innovation technologique qui prévoit de consacrer 2,5 milliards d'euros à la formation des talents de demain dans ces métiers.",
            "Il s'agirait de plus de 1,75 million de nouveaux emplois qui seraient créés d'ici là. Autrement dit, l'arrivée de l'intelligence artificielle n'a fait qu'accélérer la pénurie : les entreprises voulant en bénéficier ont besoin de développeurs pour l'adapter à leurs besoins.",
        ],
        audienceTitle: "À qui s'adresse la formation ?",
        audience: [
            "Aux professionnels à la recherche des dernières nouveautés dans le monde du développement web.",
            "Aux digital nomads, aux étudiants et aux curieux qui veulent élargir leurs compétences pour atteindre leurs projets sans forcément devoir passer par des prestataires à chaque fois.",
            "Aux entrepreneurs et aux (futurs ?) freelances qui souhaitent élargir leurs compétences ou vivre une expérience inoubliable pour accéder à de nouvelles opportunités.",
        ],
        images: ["profil-1.jpg", "profil-2.jpg", "profil-3.jpg"],
        prerequisitesTitle: "Quels sont les prérequis ?",
        prerequisites: [
            "Aucun diplôme n'est nécessaire pour intégrer notre formation développeur web.",
            "Une forte motivation et un vrai projet professionnel sont des critères prioritaires.",
            "Nous recherchons chez nos futurs étudiants de l'autonomie, un pouce de créativité et surtout une bonne humeur avec la volonté de toujours chercher à aller plus loin que ce qui est demandé.",
        ],
    },

    objectives: {
        intro: [
            "À l'issue de la formation Développeur Web (accélérateur Rocket) de Believemy, vous vous présenterez à la certification Développeur Web Tosa, délivrée par le certificateur Isograd. La certification Tosa est un standard d'évaluation des compétences numériques reconnu sur le marché du travail par de nombreuses entreprises.",
            "Notre formation prépare aux domaines de compétences de cette certification. Voici nos objectifs pédagogiques :",
        ],
        // Le détail sous chacun des six objectifs de la fiche, dans le même ordre.
        details: [
            [
                "Connaître les principes élémentaires du langage",
                "Utiliser différents éléments HTML accompagnés d'attributs",
                "Choisir les éléments HTML pertinents répondant à un besoin",
                "Utiliser des éléments HTML avancés (tableaux, formulaires…)",
            ],
            [
                "Connaître les principes de base et les règles de priorité du langage",
                "Appliquer une règle de style sur un élément avec différentes méthodes",
                "Importer du style CSS depuis une autre feuille de style",
                "Positionner des éléments dans une page, gérer les espaces, la taille des éléments et du texte",
                "Lire un fichier CSS écrit par un autre développeur et utiliser les règles CSS à l'intérieur",
            ],
            [
                "Connaître les principales caractéristiques et spécificités du langage",
                "Connaître les fonctionnalités de base et la syntaxe",
                "Créer et manipuler des objets primitifs, des objets intégrés ou des objets personnalisés plus complexes",
                "Comprendre et manipuler les propriétés d'un objet",
                "Écouter, lire et modifier le DOM (Document Object Model)",
            ],
            [
                "Intégrer conjointement du code HTML, CSS et JavaScript",
                "Écrire du code CSS de personnalisation d'affichage",
                "Écrire du code JavaScript de dynamisation de pages web",
                "Résoudre un bug à l'intérieur d'un code complexe écrit par un autre développeur",
            ],
            ["Comprendre la documentation technique d'une bibliothèque externe"],
            [
                "Trouver des clients en tant que freelance et les fidéliser",
                "Développer un personal branding pour se faire remarquer",
                "Préparer un entretien d'embauche et négocier sa rémunération",
            ],
        ],
        image: "equipe.jpg",
    },

    rhythm: {
        title: "Choisissez le rythme qui vous convient",
        paragraphs: [
            "Vous n'avez pas le temps, une famille à gérer ou déjà un temps plein ? Nos formules s'adaptent à vous : temps plein ou temps partiel, pour une formation de 1 120 heures.",
        ],
        formulas: [
            {
                title: "Temps plein : 32 semaines",
                image: "temps-plein.jpg",
                text: [
                    "Vous souhaitez aller vite ? Rendez-vous dans notre formule la plus intensive.",
                    "Suivez vos modules quand vous le souhaitez. Votre formateur vous accompagne tout au long du parcours : questions sous chaque session, Discord, e-mail et rendez-vous.",
                ],
                checks: [
                    "35 heures d'apprentissage par semaine",
                    "100 % à distance en ligne (sans horaires fixes)",
                ],
            },
            {
                title: "Temps partiel : 64 semaines",
                image: "temps-partiel.jpg",
                text: [
                    "Vous avez des contraintes ? Une vie active ? Choisissez notre formule flexible.",
                    "Apprenez pendant votre temps libre grâce au temps partiel. Les modules s'ouvrent deux fois moins vite, sur 64 semaines, et votre formateur vous accompagne jusqu'à 18 mois après votre rentrée.",
                ],
                checks: [
                    "Environ 17 heures d'apprentissage par semaine",
                    "100 % à distance en ligne (sans horaires fixes)",
                ],
            },
            {
                // Quelle que soit la formule : un point chaque semaine et des
                // visios à la demande (manuel qualité, indicateur 12).
                title: "Votre formateur vous suit",
                image: "formateur-suivi.jpg",
                text: [
                    "Chaque semaine, votre formateur fait le point sur votre progression. Vous réservez une visio dès que vous en avez besoin, et vos questions se posent sous chaque session, par e-mail ou sur Discord.",
                ],
                checks: [
                    "Une correction individuelle de chaque projet-passerelle",
                    "Un accès à vie aux contenus de la formation",
                ],
            },
        ],
    },

    modules: [
        {
            image: "bandeau-01.jpg",
            title: "Découvrir les outils du programme",
            description: [
                "Notre formation développeur web est très intense et riche en informations et en pratique. Afin de profiter pleinement de cette expérience unique dans les meilleures conditions, nous passerons ensemble sur une découverte des outils de la formation.",
                "Ce module est rapide et est le plus court de tout le programme, mais il permet d'être à l'aise tout de suite avec la plateforme, la pose des questions, les séances de visio et la communauté.",
            ],
            theory: "1 heure",
            practice: "1 heure",
            tools: ["Believemy", "Discord"],
            skills: [
                "Comprendre l'interface de la formation",
                "Savoir poser des questions",
                "Découvrir la communauté dédiée à tous les étudiants",
            ],
            doing: [
                "Créer un compte sur l'application de messagerie Discord",
                "Manipuler une interface de formation en ligne",
            ],
        },
        {
            image: "bandeau-02.jpg",
            title: "Apprendre… à apprendre",
            description: [
                "Chaque personne est différente. Chez Believemy, on croit fermement que nous ne sommes pas tous égaux face à l'apprentissage. Avant de se jeter dans les profondeurs du développement web, nous travaillerons ensemble sur l'apprentissage de soi.",
                "Vous comprendrez et déterminerez votre type de mémoire ainsi que les mythes qui entourent la programmation. Vous apprendrez également à organiser votre espace de travail afin de réduire les éléments de distraction. Enfin, vous étudierez une manière de mesurer vos progrès et de planifier votre avancée.",
            ],
            theory: "2 heures",
            practice: "5 heures",
            tools: ["Google Docs"],
            skills: [
                "Comprendre les types de mémoire et les mythes sur la programmation",
                "Mesurer les progrès réalisés",
                "Planifier les séances d'apprentissage",
                "S'ancrer dans un processus d'apprentissage actif",
            ],
            doing: [
                "Vous organiserez votre cocon d'apprentissage",
                "Vous planifierez méthodiquement vos séances d'apprentissage",
            ],
        },
        {
            image: "bandeau-03.jpg",
            title: "Équilibre et liberté",
            description: [
                "Selon une étude réalisée début 2022 par OpinionWay pour le cabinet Empreinte Humaine, 34 % des salariés seraient en burn-out, dont 13 % en burn-out sévère, soit 2,5 millions de personnes.",
                "Être développeur, c'est également devoir jouer parfois avec de la pression quand un bug critique apparaît. Nous préparons nos étudiants à mettre leurs émotions de côté et à tenir un véritable équilibre de vie pour leur santé physique et mentale. C'est un module qui nous tient énormément à cœur : selon leurs propres mots, il a plus d'une fois « sauvé » certains étudiants de Believemy.",
            ],
            theory: "2 heures",
            practice: "8 heures",
            tools: ["Google Docs", "Guide pédagogique"],
            skills: [
                "Utiliser et comprendre les objectifs SMART et SMARTER",
                "Tenir une routine d'apprentissage",
                "Mobiliser sa discipline pour vaincre la procrastination",
                "Adopter une alimentation favorisant la concentration",
            ],
            doing: [
                "Vous définirez vos objectifs et vos buts pour la fin de la formation",
                "Vous ferez une analyse des meilleurs aliments à privilégier avant une séance d'apprentissage",
                "Vous suivrez vos progrès et vous commencerez à documenter vos ressentis et émotions",
            ],
        },
        {
            image: "bandeau-04.jpg",
            title: "Comprendre le fonctionnement du web",
            description: [
                "Devenir développeur web sans comprendre le fonctionnement du web ? Impensable ! Et pourtant, de nombreux professionnels ont encore du mal avec ces notions.",
                "Nos étudiants sont préparés, eux. Au programme : ce qu'est vraiment internet, le web, le cloud et ce qu'il se passe quand on accède à un site internet.",
                "Nous comprendrons également ce qu'est un langage de programmation, comment il a été créé, comment il est mis à jour et par quel moyen se tenir informé des dernières avancées. Enfin, nous terminerons en décortiquant le fonctionnement d'un réseau.",
            ],
            theory: "2 heures",
            practice: "6 heures",
            tools: ["Un bon cahier de prise de notes"],
            skills: [
                "Comprendre le fonctionnement d'un réseau",
                "Comprendre le fonctionnement d'internet et de ses services comme le web",
                "Comprendre la structure d'un nom de domaine et le DNS",
                "Connaître les différents types de protocoles réseaux",
                "Faire la différence entre « front-end », « back-end » et « full-stack »",
                "Expliquer le fonctionnement d'une connexion à un site internet",
            ],
            doing: [
                "Vous noterez dans votre cahier de prise de notes les notions essentielles de ce module",
                "Vous apprendrez à cacher votre identité en ligne",
                "Vous transformerez un nom de domaine en adresse IP",
            ],
        },
        {
            image: "bandeau-05.jpg",
            title: "Apprendre HTML5 et CSS3 : la base d'un site",
            description: [
                "Rien ne serait possible dans la conception d'un site internet sans le langage de programmation HTML dans sa version 5, et le langage de programmation CSS dans sa version 3.",
                "Il est temps de mettre nos mains dans le cambouis et de créer notre tout premier site internet ! Vous construirez votre portfolio professionnel pas à pas, jusqu'à ses animations et sa mise en ligne.",
            ],
            theory: "15 heures",
            practice: "60 heures",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "Google Analytics"],
            skills: [
                "Installer et configurer son environnement de travail en fonction du projet web ou web mobile",
                "Maquetter des interfaces utilisateur web ou web mobile",
                "Réaliser des interfaces utilisateur statiques web ou web mobile",
                "Utiliser le HTML5 pour créer la structure d'un site web",
                "Utiliser le CSS3 pour styliser les éléments d'un site web",
                "Créer des animations professionnelles avec CSS",
            ],
            doing: [
                "+60 heures de pratique",
                "Vous créerez votre portfolio professionnel, de la première page HTML à sa mise en ligne",
                "Vous créerez des mises en page modernes avec Flexbox et CSS Grid",
                "Vous adapterez votre portfolio aux mobiles et autres périphériques avec le « responsive design »",
                "Vous animerez un bouton d'appel à l'action et créerez des formulaires professionnels",
            ],
        },
        {
            image: "bandeau-06.jpg",
            title: "Utiliser Git et GitHub pour ne plus rien perdre",
            description: [
                "Imaginez juste que votre ordinateur tombe en panne et que son disque dur ne soit plus d'un seul coup qu'une coquille inutilisable ? Tous vos fichiers seraient détruits pour toujours.",
                "Il est tout bonnement impensable pour un développeur de perdre l'accès à son code. Nous apprendrons heureusement à utiliser un outil incontournable : Git. Cet outil vous permettra de stocker plusieurs versions de vos projets afin de pouvoir facilement revenir en arrière.",
                "Nous le combinerons avec un des services les plus utilisés par les développeurs : GitHub. Grâce à ce service gratuit, nous gagnerons en sérénité car nos codes seront stockés en ligne. Nous verrons aussi comment travailler à plusieurs grâce à GitHub : un excellent outil de collaboration.",
            ],
            theory: "4 heures",
            practice: "20 heures",
            tools: ["Visual Studio Code", "Git", "GitHub", "Terminal"],
            skills: [
                "Installer un système de gestion de versions Git",
                "Utiliser GitHub comme dépôt distant",
                "Comprendre et créer des branches ainsi que des commits",
                "Fusionner différentes branches ensemble",
                "Utiliser Git rebase",
            ],
            doing: [
                "+20 heures de pratique",
                "Vous utiliserez le terminal de votre ordinateur pour installer Git",
                "Vous utiliserez GitHub pour envoyer votre portfolio",
            ],
        },
        {
            image: "bandeau-07.jpg",
            title: "Mettre son site internet en ligne",
            description: [
                "Avoir un site internet sur votre ordinateur, on peut dire que c'est assez sympa. Mais en faire bénéficier le monde entier, ça donne fortement envie !",
                "Nous apprendrons comment mettre votre site web en ligne, comment vous pouvez créer vos propres adresses e-mail professionnelles, comment ajouter un autre site sur votre hébergement et surtout ce que cela peut bien vouloir dire.",
            ],
            theory: "2 heures",
            practice: "12 heures",
            tools: ["Visual Studio Code", "Hostinger", "FileZilla"],
            skills: [
                "Comprendre le fonctionnement d'un nom de domaine",
                "Comprendre le fonctionnement d'un serveur",
                "Savoir mettre en production un site web",
                "Créer des adresses e-mail avec un nom de domaine",
                "Maîtriser un outil permettant l'envoi FTP grâce à FileZilla",
            ],
            doing: [
                "+12 heures de pratique",
                "Vous créerez votre propre nom de domaine ainsi qu'une adresse e-mail professionnelle",
                "Vous utiliserez un logiciel d'envoi vers un serveur",
                "Vous mettrez en ligne votre projet de portfolio",
            ],
        },
        {
            image: "bandeau-08.jpg",
            title: "Maîtriser pleinement les interactions avec JavaScript",
            description: [
                "Le JavaScript est un langage de programmation qui domine le monde du développement web depuis déjà plusieurs années : c'est tout simplement un incontournable.",
                "Avec JavaScript vous apprendrez à concevoir des interactions sur vos sites web. Créer une expérience interactive ou un jeu sera possible à la fin du module. C'est d'ailleurs ce que vous ferez dans le programme ! JavaScript sera la base des technologies que nous utiliserons dans la suite du programme, il convient donc de prendre notre temps afin d'en maîtriser tous les aspects.",
            ],
            theory: "14 heures",
            practice: "100 heures",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "JavaScript"],
            skills: [
                "Développer la partie dynamique des interfaces utilisateur web ou web mobile",
                "Faire des algorithmes avec JavaScript",
                "Utiliser les événements, les API et les fonctions asynchrones avec JavaScript",
            ],
            doing: [
                "+100 heures de pratique",
                "Vous générerez la fiche d'un personnage de jeu de rôle, puis un système de notation automatique",
                "Vous créerez le tableau de bord d'une boutique et un annuaire de contacts dynamique",
                "Vous coderez un bouton thème sombre / thème clair et une todo list qui se souvient de vos tâches",
                "Vous afficherez la météo de votre ville grâce à une API",
                "Vous terminerez par un système de combat Pokémon en programmation orientée objet",
            ],
        },
        {
            image: "bandeau-09.jpg",
            project: 1,
            title: "Projet-passerelle #1",
            description: PROJET,
            duration: "2 semaines",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "JavaScript", "Git", "GitHub", "Terminal"],
            skills: [COMPETENCE_PROJET],
            doing: ["Un jeu du pendu interactif"],
        },
        {
            image: "bandeau-10.jpg",
            title: "Programmer dans les feuilles de style avec Sass",
            description: [
                "Sass est un préprocesseur CSS.",
                "C'est en quelque sorte une technologie qui va permettre d'ajouter des fonctions bien utiles au langage de programmation CSS.",
                "Nous apprendrons à utiliser de la logique dans nos feuilles de style.",
            ],
            theory: "4 heures",
            practice: "20 heures",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "Sass"],
            skills: [
                "Maîtriser l'utilisation d'un préprocesseur CSS",
                "Utiliser les fonctions, les boucles et tous les aspects logiques grâce à Sass",
            ],
            doing: [
                "+20 heures de pratique",
                "Vous créerez un véritable générateur de couleurs rien qu'avec le préprocesseur Sass",
            ],
        },
        {
            image: "bandeau-11.jpg",
            title: "Créer des designs simples et élégants avec Bootstrap",
            description: [
                "Bootstrap est une bibliothèque CSS.",
                "Il s'agit d'une énorme collection de classes déjà prêtes à l'utilisation pour nous permettre en tant que développeur de faire nos designs plus rapidement.",
                "Encore plus que des classes pour le CSS, Bootstrap vient avec une panoplie d'éléments que nous pouvons intégrer comme des menus et des boutons. Nous verrons enfin comment personnaliser Bootstrap avec Sass, pour qu'il suive votre charte graphique.",
            ],
            theory: "7 heures",
            practice: "30 heures",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "Bootstrap", "Sass"],
            skills: [
                "Maîtriser l'utilisation d'une bibliothèque CSS avec Bootstrap",
                "Ajouter et utiliser des éléments provenant d'une dépendance tierce sur un site web",
                "Réaliser des interfaces utilisateur statiques web ou web mobile",
                "Personnaliser les classes de Bootstrap grâce au préprocesseur Sass",
            ],
            doing: [
                "+30 heures de pratique",
                "Vous créerez un clone de l'interface de Tinder, l'application de rencontre",
                "Vous coderez un clone de l'interface de Tesla",
                "Vous ferez ensuite une interface de boutique basée sur Harry Potter",
            ],
        },
        {
            image: "bandeau-12.jpg",
            title: "Gérer des données avec PHP et MySQL",
            description: [
                "PHP est un langage de programmation principalement utilisé côté « back-end ».",
                "Il permet par exemple de retourner des résultats et donc de faire des algorithmes, mais également de sauvegarder des données grâce notamment au langage SQL et à MySQL.",
                "Il s'agit du module qui marquera le début d'une passion pour le « back-end » chez certains. Vous aurez la possibilité de refaire la majorité des sites que vous connaissez une fois ce module complété.",
            ],
            theory: "13 heures",
            practice: "80 heures",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "PHP", "SQL", "MySQL"],
            skills: [
                "Développer des composants métier côté serveur",
                "Mettre en place une base de données relationnelle",
                "Développer des composants d'accès aux données SQL",
                "Utiliser un langage de programmation pour garder en base de données des informations",
            ],
            doing: [
                "+80 heures de pratique",
                "Vous coderez un décompte pour perdre du poids",
                "Vous vous exercerez sur une liste de courses, une table de multiplication et une fiche de police",
                "Vous créerez un hébergeur d'images",
                "Vous concevrez un raccourcisseur d'URL comme le site bit.ly",
                "Vous vous initierez à l'authentification grâce à une copie de l'espace membre de Netflix",
            ],
        },
        {
            image: "bandeau-13.jpg",
            title: "Structurer les projets avec MVC",
            description: [
                "Le MVC est un modèle dans la conception d'applications, de logiciels et de sites web.",
                "Il met l'accent sur la séparation entre la logique métier et l'affichage. Cette séparation permet une meilleure répartition du travail ainsi qu'un code plus facilement maintenable.",
                "Très utilisé avec PHP, vous apprendrez à vous servir de ce modèle pour structurer vos projets proprement.",
            ],
            theory: "3 heures",
            practice: "20 heures",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "PHP", "SQL", "MySQL"],
            skills: [
                "Développer des composants métier côté serveur",
                "Mettre en place une base de données relationnelle",
                "Développer des composants d'accès aux données SQL",
                "Utiliser un modèle de conception afin de créer un code propre et maintenable",
            ],
            doing: [
                "+20 heures de pratique",
                "Vous transformerez un site réalisé avec PHP en modifiant sa structure grâce au modèle MVC",
            ],
        },
        {
            image: "bandeau-14.jpg",
            project: 2,
            title: "Projet-passerelle #2",
            description: PROJET,
            duration: "2 semaines",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "Sass", "Bootstrap", "Git", "GitHub", "SQL", "MySQL", "PHP", "Terminal"],
            skills: [COMPETENCE_PROJET],
            doing: ["Un blog interactif avec système de gestion attaché à un portfolio"],
        },
        {
            image: "bandeau-15.jpg",
            title: "Dominer les moteurs de recherche avec le SEO",
            description: [
                "Le SEO (Search Engine Optimization) est un terme qui définit l'ensemble des techniques mises en œuvre pour améliorer la position de votre site web dans les SERP (les pages affichant les résultats sur un moteur de recherche).",
                "Un développeur web se doit de créer un site web optimisé pour le référencement dès l'étape de conception du projet.",
                "Nous ferons donc un tour des meilleures pratiques de référencement.",
            ],
            theory: "4 heures",
            practice: "20 heures",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "Google Business"],
            skills: [
                "Mettre en place des optimisations SEO On-Page",
                "Mettre en place des optimisations SEO On-Site",
                "Mettre en place des optimisations SEO Off-Site",
                "Élaborer une stratégie de référencement",
            ],
            doing: [
                "+20 heures de pratique",
                "Vous créerez une stratégie de référencement multicanale",
            ],
        },
        {
            image: "bandeau-16.jpg",
            title: "Maîtriser pleinement le JavaScript avec ReactJS",
            description: [
                "ReactJS est une librairie JavaScript permettant de créer des interfaces utilisateurs réactives. Elle introduit la notion de SPA (Single Page Application), un site internet composé d'une unique page dont le contenu se met à jour en fonction de l'adresse ou de l'interaction de l'utilisateur.",
                "Elle permet de réaliser des sites web rapides, sans besoin de rechargement, fluides et en délivrant une expérience utilisateur exceptionnelle. ReactJS est utilisée par exemple dans les sites web de Netflix, Instagram et Facebook.",
            ],
            theory: "21 heures",
            practice: "130 heures",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "JavaScript", "ReactJS", "Terminal", "Framer Motion", "Tanstack Query", "React Router", "React Hook Form"],
            skills: [
                "Développer la partie dynamique des interfaces utilisateur web ou web mobile",
                "Programmer des Single Page Applications",
                "Mettre en ligne une application web réalisée grâce à React",
                "Savoir utiliser Framer Motion, Tanstack Query, React Hook Form, React Router et les hooks",
            ],
            doing: [
                "+130 heures de pratique",
                "Un prévisualisateur de markdown",
                "Une TO-DO list",
                "Un véritable pokédex avec génération d'un nouveau pokémon",
                "Un clone partiel de l'Apple Store",
                "Un clone du système d'authentification de Facebook",
            ],
        },
        {
            image: "bandeau-17.jpg",
            project: 3,
            title: "Projet-passerelle #3",
            description: PROJET,
            duration: "2 semaines",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "JavaScript", "ReactJS", "Terminal", "Git", "GitHub"],
            skills: [COMPETENCE_PROJET],
            doing: ["Un clone de Twitter (désormais X)"],
        },
        {
            image: "bandeau-18.jpg",
            title: "Développer des applications full-stack en JavaScript avec NextJS et ReactJS",
            description: [
                "NextJS est un framework.",
                "Contrairement à une librairie, l'utilisation d'un framework permet d'encadrer les pages d'un projet afin d'ajouter quelques fonctionnalités automatisées supplémentaires.",
                "C'est par exemple une des spécificités de NextJS que de créer sans action nécessaire du développeur les adresses URL (appelées routes) pour afficher certaines pages. NextJS permet aussi une optimisation parfaite des balises meta, des images ainsi que des rendus statiques, incrémentaux et à la demande grâce au serveur.",
            ],
            theory: "13 heures",
            practice: "100 heures",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "JavaScript", "ReactJS", "Terminal", "NextJS", "Tailwind CSS"],
            skills: [
                "Développer la partie dynamique des interfaces utilisateur web ou web mobile",
                "Concevoir un site web optimisé pour le référencement naturel grâce à NextJS",
                "Générer des pages avec un rendu statique, incrémental ou par le serveur",
            ],
            doing: [
                "+100 heures de pratique",
                "Vous vous entraînerez avec plusieurs petits challenges",
                "Vous créerez un clone complet du réseau social Threads",
            ],
        },
        {
            image: "bandeau-19.jpg",
            title: "Créer rapidement des designs sans quitter votre HTML avec Tailwind CSS",
            description: [
                "Tailwind CSS est une librairie proposant des classes prêtes à l'usage.",
                "Contrairement à Bootstrap, elle permet d'utiliser des classes utilitaires permettant de styliser complètement une application sans jamais toucher à une seule ligne de code CSS. Vous apprendrez à faire des éléments adaptés à tous les périphériques et à changer les propriétés de ces derniers au survol ou au clic.",
                "Utilisée avec le framework NextJS, elle permet en plus de générer une feuille de style n'incluant que les classes utilisées et supprimant toutes les autres pour les performances.",
            ],
            theory: "4 heures",
            practice: "20 heures",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "JavaScript", "ReactJS", "Terminal", "NextJS", "Tailwind CSS"],
            skills: [
                "Maquetter des interfaces utilisateur web ou web mobile",
                "Intégrer un design grâce à la librairie Tailwind CSS",
                "Personnaliser Tailwind CSS",
            ],
            doing: [
                "+20 heures de pratique",
                "Vous vous entraînerez avec des exercices sur flexbox, les grilles, les états et le responsive design",
                "Vous mettrez en place un mode sombre et personnaliserez Tailwind CSS",
            ],
        },
        {
            // Photo des figurines de LN, pas une image générée.
            image: "bandeau-20.jpg",
            title: "Devenir développeur à l'heure de l'IA avec Claude Code",
            description: [
                "L'intelligence artificielle a changé la façon de coder. Un développeur qui sait s'en servir va beaucoup plus vite, à condition de garder la main sur son code.",
                "Dans ce module, vous apprendrez à installer et configurer Claude Code, l'assistant de programmation d'Anthropic, à lui écrire des consignes professionnelles et à sécuriser votre projet avec Git. Vous comprendrez comment il fonctionne, pour relire ce qu'il produit et le corriger quand il se trompe.",
            ],
            theory: "5 heures",
            practice: "35 heures",
            tools: ["Visual Studio Code", "Claude Code", "Terminal", "Git"],
            skills: [
                "Installer et configurer Claude Code",
                "Écrire des prompts professionnels",
                "Utiliser les commandes, les raccourcis et les workflows avancés de Claude Code",
                "Sauvegarder et sécuriser son projet avec Git",
            ],
            doing: [
                "+35 heures de pratique",
                "Vous créerez un site web moderne avec Claude Code",
                "Vous créerez une application mobile moderne avec Claude Code",
            ],
        },
        {
            image: "bandeau-21.jpg",
            title: "Réussir son entretien d'embauche",
            description: [
                "Nos étudiants sont entraînés à passer et surtout à réussir des entretiens d'embauche.",
                "Il nous est inconcevable de lâcher dans la nature nos nouveaux développeurs sans accompagnement jusqu'à l'emploi.",
                "Dans ce module, vous apprendrez à préparer un entretien d'embauche, passer un test technique et faire une excellente impression. Vous apprendrez par exemple à préparer vos questions mais aussi à négocier votre rémunération.",
            ],
            theory: "3 heures",
            practice: "9 heures",
            tools: CARNET,
            skills: ["Préparer un entretien d'embauche"],
            doing: ["+9 heures de pratique", "Vous préparerez un entretien d'embauche"],
        },
        {
            image: "bandeau-22.jpg",
            title: "Trouver des clients en tant que freelance",
            description: [
                "Selon « lesmakers », le nombre de freelances devrait atteindre 1,5 million de personnes d'ici 2030. 45 % des freelances sont actuellement des femmes en France, contre 35 % dans l'Union européenne, et le taux journalier moyen serait autour de 478 euros par jour.",
                "Beaucoup de nos étudiants deviennent freelances après notre formation développeur web. Les avantages sont très nombreux : gestion de votre propre emploi du temps, de vos propres clients, de vos congés et également de vos propres décisions.",
                "Ce module vous permettra de trouver des clients puis de les fidéliser.",
            ],
            theory: "3 heures",
            practice: "16 heures",
            tools: CARNET,
            skills: ["Trouver des clients en tant que freelance et les fidéliser"],
            doing: [
                "+16 heures de pratique",
                "Vous préparerez une stratégie d'acquisition et de fidélisation",
            ],
        },
        {
            image: "bandeau-23.jpg",
            title: "Développer son personal branding pour se faire remarquer",
            description: [
                "Depuis quelques années, nous voyons l'arrivée d'une tendance déjà bien présente dans le reste du monde : l'économie de l'influence et de l'attention.",
                "Ceux qui sont visibles sont généralement ceux qui font le plus de ventes. Ce sont aussi eux qui remontent dans les sélections pour trouver un emploi.",
                "L'ère de LinkedIn permet de trouver facilement un emploi et des clients, autant apprendre à le faire de la meilleure des manières.",
            ],
            theory: "2 heures",
            practice: "4 heures",
            tools: CARNET,
            skills: ["Développer un personal branding fort"],
            doing: [
                "+4 heures de pratique",
                "Vous préparerez une stratégie de croissance et de communication",
            ],
        },
        {
            image: "bandeau-24.jpg",
            title: "L'art de concrétiser un projet",
            description: [
                "Commencer un nouveau projet n'est pas vraiment difficile.",
                "Le concrétiser relève cependant d'une force et d'une discipline à adopter pour passer les différentes étapes évidentes de démotivation ainsi que de procrastination.",
                "Vous verrez dans ce module une méthode d'organisation, de suivi et de planification qui vous permettra de le faire.",
            ],
            theory: "3 heures",
            practice: "9 heures",
            tools: CARNET,
            skills: ["Organiser et manager un projet"],
            doing: [
                "+9 heures de pratique",
                "Vous préparerez une stratégie d'organisation et de gestion pour concrétiser un projet",
            ],
        },
        {
            image: "bandeau-25.jpg",
            title: "Imaginer et concevoir le design de ses pages",
            description: [
                "Ce module dédié à la conception et au maquettage vous permettra d'imaginer et de concevoir votre site web.",
                "Il permet de faire un rappel de toutes les bonnes pratiques tout en délivrant de précieuses connaissances de charte graphique.",
            ],
            theory: "1 heure",
            practice: "3 heures",
            tools: CARNET,
            skills: ["Maquetter des interfaces utilisateur web ou web mobile"],
            doing: [
                "+3 heures de pratique",
                "Vous créerez des maquettes en partant d'un simple schéma (wireframe)",
            ],
        },
        {
            image: "bandeau-26.jpg",
            title: "Savoir s'organiser au quotidien",
            description: [
                "Ce module vous permettra de faire un point sur l'organisation quotidienne que vous devez avoir dans votre nouvelle carrière de développeur web, que ce soit en tant que freelance ou dans une entreprise.",
            ],
            theory: "1 heure",
            practice: "3 heures",
            tools: CARNET,
            skills: ["Savoir mettre en place une organisation durable pour se maintenir à jour"],
            doing: [
                "+3 heures de pratique",
                "Vous ferez un point sur les habitudes à adopter pour vous maintenir à jour des technologies",
            ],
        },
        {
            image: "bandeau-27.jpg",
            project: 4,
            title: "Projet-passerelle #4",
            description: PROJET,
            duration: "2 semaines",
            tools: ["Visual Studio Code", "HTML5", "CSS3", "JavaScript", "ReactJS", "Terminal", "Git", "GitHub", "NextJS"],
            skills: [
                COMPETENCE_PROJET,
                "Présenter son activité de développeur freelance : statut, tarif journalier et premiers clients visés",
            ],
            doing: [
                "Un projet au choix sorti entièrement de votre imagination",
                "Vous présenterez votre activité : le statut choisi, votre tarif journalier calculé avec l'outil Combien facturer et les premiers clients que vous visez",
            ],
        },
    ],

    github: {
        title: "Un organisme reconnu par GitHub Global Campus",
        paragraphs: [
            "Believemy est un organisme de formation reconnu par GitHub dans son programme GitHub Global Campus.",
            "Celui-ci permet à tous nos étudiants formés dans notre formation développeur web d'avoir en exclusivité l'accès à des offres inédites comme un nom de domaine offert, des serveurs et hébergements de sites web ainsi que des milliers de licences gratuites (par exemple, vous aurez un accès gratuit et complet à GitHub Copilot).",
        ],
        perks: [
            ["jetbrains", "Tous les logiciels offerts"],
            ["copilot", "GitHub Copilot"],
            ["namecheap", "Un nom de domaine offert"],
            ["azure", "Tous les services Microsoft Azure"],
            ["tech", "Un nom de domaine .tech offert"],
            ["heroku", "13 $ de crédits offerts chaque mois pendant 24 mois"],
            ["stripe", "Pas de commission sur vos 1 000 premiers euros"],
            ["mongodb", "50 $ de crédits Atlas"],
            ["1password", "Une année offerte"],
        ],
    },

    method: {
        intro: [
            "Chez Believemy, nous favorisons un apprentissage basé sur la pratique avec deux tiers de projets et un tiers de théorie en apprentissage « actif ».",
            "Notre méthode pédagogique propose différents types de formats.",
        ],
        groups: [
            [
                "Aborder les concepts-clés",
                [
                    ["des modules distincts", "Grâce à ", ", vidéos ou textuels et accessibles à n'importe quel moment"],
                    ["des ateliers en direct", "Avec ", ", proposés de temps en temps en visioconférence avec le formateur pour pousser certains sujets et répondre en direct aux questions"],
                ],
            ],
            [
                "Mettre en pratique",
                [
                    ["les challenges", "Par ", ", des moments omniprésents dans les sessions dans lesquels vous êtes invité à mettre en pause pour pratiquer un challenge avant de le corriger"],
                    ["les exercices", "Par ", ", des sessions dédiées avec des petits bouts de code à faire"],
                    ["les projets intra-formation", "Par ", ", des vrais projets construits dans les formations de A à Z"],
                    ["les projets-passerelles", "Par ", ", des projets professionnalisants complets mêlant plusieurs outils, langages de programmation et technologies, évalués par le formateur"],
                ],
            ],
            [
                "Faire le point ensemble",
                [
                    ["les discussions instantanées", "Par ", ", sur le salon de conversation de la formation"],
                    ["un point individualisé", "Par ", " avec le formateur"],
                    ["les ateliers", "Par ", " en visioconférence"],
                    ["les retours", "Avec ", " rendus à chaque étudiant après chaque projet-passerelle"],
                ],
            ],
            [
                "Rencontrer des professionnels",
                [
                    ["les ateliers en direct", "Par ", ", proposés de temps en temps et parfois animés avec un professionnel invité, où chaque étudiant de la formation peut poser toutes ses questions"],
                ],
            ],
        ],
        speakersTitle: "Nos conférenciers invités en 2023",
        speakers: [
            ["lior-chamla", "Lior Chamla", "Développeur Symfony et React"],
            ["emmanuel-demey", "Emmanuel Demey", "Organisateur du DevFest Lille et consultant web"],
            ["mansour-mahamat", "Mansour Mahamat", "Développeur front-end et Indie Hackers"],
            ["alexandre-soyer", "Alexandre Soyer", "Développeur full-stack"],
            ["axel-paris", "Axel Paris", "Entrepreneur"],
        ],
        uniqueTitle: "Ce qui rend Believemy particulièrement unique :",
        unique: [
            "Une formation orientée pratique, avec la possibilité d'être en groupe",
            "Un accès à vie à vos modules et à leurs mises à jour",
            "Un accès à notre communauté des alumni",
            "Un suivi personnalisé pour ne pas rester bloqué",
            "Un pack complet d'outils offerts avec GitHub Global Campus",
            "Des ateliers en direct, proposés de temps en temps, parfois avec un professionnel invité",
        ],
    },

    means: {
        intro: "Afin de valider avec succès notre formation développeur web, Believemy accompagne ses étudiants grâce à des suivis individualisés, des ateliers en groupe et des outils dédiés.",
        blocks: [
            [
                "Une plateforme pédagogique complète",
                "Notre organisme dispose de sa propre plateforme pédagogique avec une partie dédiée aux étudiants de la formation développeur web. Chaque étudiant dispose de son propre tableau de bord dans lequel il voit :",
                [
                    "les modules sortis et ceux bientôt disponibles",
                    "sa progression sur le programme",
                    "les rediffusions des visioconférences",
                    "les rapports sur les projets-passerelles qu'il a rendus",
                    "les accès uniques à nos offres partenaires et à GitHub Global Campus",
                    "les documents attestant de sa participation à notre formation",
                ],
            ],
            [
                "Un salon de discussion en temps réel",
                "Believemy dispose de son propre salon de discussion en temps réel regroupant les anciens étudiants du programme, les nouveaux étudiants accompagnés et le formateur. Cette proximité quotidienne amène une atmosphère de bienveillance, d'entraide et d'écoute entre tout le monde. Nos étudiants restent ainsi en contact entre eux, ils collaborent même assez souvent sur des projets personnels, et sont toujours en contact avec leur formateur.",
                [],
            ],
            [
                "Des ressources pédagogiques plurielles",
                "Notre programme regroupe des ressources pédagogiques de plusieurs natures :",
                [
                    "des sessions vidéo",
                    "des sessions textuelles",
                    "des visioconférences en direct",
                    "des rediffusions",
                    "des guides pédagogiques",
                    "des eBooks exclusifs",
                ],
            ],
        ],
    },

    followUp: {
        participation: [
            "les journaux de connexion (progression) à la plateforme pédagogique",
            "l'utilisation de la messagerie instantanée",
            "l'utilisation des questions intégrées à la plateforme pédagogique",
            "les réponses aux quiz et la remise des travaux demandés par le formateur",
            "les rendez-vous de suivi avec le formateur",
        ],
        evaluation: [
            "La certification Développeur Web Tosa est composée de 35 questions et dure 90 minutes. Elle est proposée par le certificateur Isograd et se passe à distance, sous surveillance.",
            "Elle s'appuie sur une base de données de plus de 130 questions de typologies variées, comme des QCM ou des exercices pratiques qui immergent le candidat dans l'environnement du logiciel et lui permettent de réaliser des cas concrets rencontrés en entreprise.",
            "Chaque test Tosa est unique : l'algorithme du test adapte la difficulté des questions en fonction du niveau de réponse du candidat. Une fois la certification passée, il obtient un score sur 1 000 associé à un niveau de compétences (de débutant à expert).",
            "À partir de 551 points, le candidat reçoit son certificat par e-mail, dans un délai de 10 jours ouvrables. En dessous, une attestation de passage lui est délivrée.",
            "Une évaluation blanche dans les conditions réelles de l'examen, proposée à l'apprenant qui en a besoin, ainsi que le passage de l'examen pour une session sont inclus dans les frais de formation. Le candidat peut demander à repasser son examen s'il ne l'a pas réussi ; une tarification lui est alors proposée au coût de 460 € TTC.",
            "Quelques jours avant l'épreuve, un essai technique en visio avec votre formateur vérifie votre matériel.",
            "L'apprenant doit également réaliser 4 projets-passerelles. Ce sont des mises en situation réelle, avec des consignes et des contraintes techniques, qui amènent à la réalisation d'un projet complet, corrigé individuellement par le formateur avec un retour écrit.",
            "Tout au long du parcours, des quiz vérifient les acquis : chaque réponse est expliquée, et un quiz n'est validé qu'à partir de 70 % de bonnes réponses.",
        ],
        technical: [
            "Connexion internet : haut débit",
            "Système d'exploitation : Windows, Linux ou macOS",
            "Logiciels particuliers : Visual Studio Code, Apache, Git, etc. (tous gratuits)",
            "Équipements nécessaires pour la formation : un ordinateur, un dispositif d'enregistrement de la voix (micro ou micro-casque), un dispositif d'écoute (enceintes ou casque), une webcam",
        ],
    },

    career: {
        pathway:
            "La certification Tosa Développeur Web n'est pas enregistrée auprès de France compétences : elle n'a ni équivalence ni passerelle avec d'autres certifications. Après la formation, vous pouvez exercer en freelance ou en entreprise, ou poursuivre vers une formation de niveau supérieur.",
        indicatorIntro:
            "La qualité de notre formation nous est précieuse, mais le ressenti de nos étudiants l'est tout autant. Chaque étudiant se voit proposer de remplir un questionnaire de satisfaction à la fin de sa formation.",
        outlets: [
            "En suivant cette formation en ligne, vous pourrez exercer les métiers d'intégrateur web, développeur front-end, développeur web, développeur back-end ou encore développeur React.",
            "Les métiers de développement se classent à la première place des métiers les plus recherchés dans le secteur du numérique (source : GEN, Grande École du Numérique, janvier 2023).",
        ],
        salaries: [
            "34 000 € pour un profil débutant",
            "53 000 € pour un profil confirmé",
        ],
        salariesNote:
            "Cette fourchette peut toutefois varier selon la taille de l'entreprise et la région (source : fiche de l'APEC). Les opportunités d'emploi sont nombreuses partout en France. Le métier de développeur peut s'exercer en entreprise, mais aussi en freelance.",
        missions: [
            "Créer une application web complète et responsive pour permettre à l'entreprise ou au client de vendre ses produits et services en ligne, sur tous types d'appareils.",
            "Dynamiser des pages web pour mieux mettre en valeur les produits et services de l'entreprise ou du client.",
            "Créer des interfaces communiquant avec le back-end du site pour élaborer des applications dynamiques et permettre aux clients de s'identifier sur le site.",
            "Optimiser les performances et réaliser la maintenance de sites web déjà existants pour permettre leur fonctionnement optimal et une bonne visibilité sur les moteurs de recherche.",
            "Gérer un projet web de A à Z : du chiffrage et du découpage des tâches du projet à la présentation de la solution, en passant par la rédaction des spécifications techniques.",
        ],
        technologies:
            "HTML5, CSS3, Sass, JavaScript, Bootstrap, Tailwind CSS, PHP, MySQL, React, Framer Motion, Tanstack Query, les appels API, NextJS, Git, GitHub, Claude Code, le SEO, Visual Studio Code, le responsive design, le marketing, la prospection, la facturation",
    },
};
